import { render, staticRenderFns } from "./FeeConfigDetailHis.vue?vue&type=template&id=de7d9c1c&scoped=true"
import script from "./FeeConfigDetailHis.vue?vue&type=script&lang=js"
export * from "./FeeConfigDetailHis.vue?vue&type=script&lang=js"
import style0 from "./FeeConfigDetailHis.vue?vue&type=style&index=0&id=de7d9c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7d9c1c",
  null
  
)

export default component.exports